import React, { CSSProperties } from 'react'
const tabs: string[] = ['基本信息', '价格信息', '付款条件', '相关附件', '成本归集']
import { Icon } from 'antd'
import { Link } from 'react-router-dom'
import AppAction from 'components/AppAction/AppAction'

interface IProps {
	dataList?: any
	changedata?: (data: any) => void
	className?: string
	style?: CSSProperties
	top?: string
	left?: string
}

export default class AppFormHighLight extends React.Component<IProps, {}> {
	state = {
		dataList: null as any,
		onclick: false,
		display: false,
	}
	componentDidUpdate = () => {
		if (this.props.dataList !== this.state.dataList) {
			this.setState({ dataList: this.props.dataList })
		}
	}
	handleClick = (e: any) => {
		e.stopPropagation()
		this.setState({ onclick: !this.state.onclick })
	}

	handleDisplay = () => {
		this.setState({ display: !this.state.display })
	}

	handleLeave = (e: any) => {
		if (this.state.display === true) {
			this.setState({ display: !this.state.display })
		}
	}

	handleMouseLeave = (e: any, field: string) => {
		// 1
		e.cancelBubble = true
		e.stopPropagation()
		const { dataList } = this.state
		dataList[field].highLight = false
		this.props.changedata && this.props.changedata(dataList)
	}

	handleMouseEnter = (e: any, field: string) => {
		// 1
		e.cancelBubble = true
		e.preventDefault()
		e.stopPropagation()
		let newdata = this.state.dataList
		newdata[field].highLight || (newdata[field].highLight = true)
		newdata[field].highLight = true
		this.setState({ dataList: newdata })
		this.props.changedata && this.props.changedata(newdata)
	}

	render() {
		const { dataList, onclick, display } = this.state
		return (
			<div
				style={{
					display: 'inline-block',
					paddingLeft: 20,
					paddingRight: 20,
					textAlign: 'center',
					position: 'fixed',
					left: '85%',
					top: '12%',
					zIndex: 999999,
				}}
				onMouseLeave={e => this.handleLeave(e)}
			>
				<AppAction icon="setting" title="操作" action={this.handleDisplay} />
				{display ? (
					<div
						className={`app-highlight ${this.props.className}`}
						style={{ top: this.props.top, left: this.props.left }}
					>
						<div className="app-highlight-div" onClick={e => this.handleClick(e)}>
							<Icon type="edit" /> 编辑组件
							<Icon type={onclick ? 'down' : 'left'} style={{ position: 'relative', left: '50%' }} />
						</div>

						{dataList && onclick
							? Object.keys(dataList).map((dataListvalue, index) => {
									return (
										<Link
											to={dataList[dataListvalue].URL || '/modeling/FormDemo'}
											key={index + dataListvalue}
											style={{ color: '#000' }}
										>
											<div
												className="app-highlight-div-child"
												style={{ fontSize: '0.8rem' }}
												key={index}
												onMouseEnter={e => this.handleMouseEnter(e, dataListvalue)}
												onMouseLeave={e => this.handleMouseLeave(e, dataListvalue)}
											>
												<Icon type="form" />
												{dataList[dataListvalue].title}
											</div>
										</Link>
									)
							  })
							: null}
						<Link to={'/modeling/FormDemo'} style={{ color: '#000' }}>
							<div className="app-highlight-div">
								<Icon type="edit" /> 编辑页面
							</div>
						</Link>
						<Link to={'/modeling/module'} style={{ color: '#000' }}>
							<div className="app-highlight-div">
								<Icon type="setting" /> 设置
							</div>
						</Link>
					</div>
				) : null}
			</div>
		)
	}
}



// WEBPACK FOOTER //
// ./src/modules/modeling/page/AppFormHighLight.tsx